import { PrivateChannel } from '@/realtime/channels/private/privateChannel';
// eslint-disable-next-line import/prefer-default-export
export class UserChannel extends PrivateChannel {
    constructor(uuid) {
        super(`user_${uuid}`);
    }
}
